<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Yeni Lider Ekle">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek lider bağlantı linki benzersiz
                olmalıdır...</span
              >
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/our-leaders"
          >
            Lider Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Lider Ekleme Formu">
            <b-row>
              <b-col cols="6">
                <b-form-group label="Ad" label-for="firstName">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Ad"
                  >
                    <b-form-input
                      id="firstName"
                      v-model="firstName"
                      placeholder="Ad"
                      :state="errors.length > 0 ? false : null"
                      :class="firstName.length >= chars.firstName ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="firstName.length >= chars.firstName ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ firstName.length }}</span>
                      /
                      {{ chars.firstName }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Soyad" label-for="lastName">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Ad"
                  >
                    <b-form-input
                      id="lastName"
                      v-model="lastName"
                      placeholder="Soyad"
                      :state="errors.length > 0 ? false : null"
                      :class="lastName.length >= chars.lastName ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="lastName.length >= chars.lastName ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ lastName.length }}</span>
                      /
                      {{ chars.lastName }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Bağlantı Başlığı" label-for="linktTitle">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Bağlantı Başlığı"
                  >
                    <b-form-input
                      id="linkTitle"
                      v-model="linkTitle"
                      placeholder="Bağlantı Başlığı"
                      :state="errors.length > 0 ? false : null"
                      :class="linkTitle.length >= chars.linkTitle ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="linkTitle.length >= chars.linkTitle ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ linkTitle.length }}</span>
                      /
                      {{ chars.linkTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Ünvan" label-for="title">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Ünvan"
                  >
                    <b-form-input
                      id="title"
                      v-model="title"
                      placeholder="Ünvan"
                      :state="errors.length > 0 ? false : null"
                      :class="title.length >= chars.title ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="title.length >= chars.title ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ title.length }}</span>
                      /
                      {{ chars.linkTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="İçerik" label-for="text">
                  <!-- <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="İçerik"
                  > -->
                  <editor ref="refEditor"></editor>
                  <!-- <quill-editor
                      id="text"
                      v-model="text"
                      :options="snowOption"
                      :state="errors.length > 0 ? false : null"
                    /> -->
                  <!-- <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <DragDropImage
                  ref="refCardImage"
                  title="Lider Görseli"
                  :imageUrl="null"
                  :required="true"
                  :width="1200"
                  :height="630"
                  :wheel="false"
                  :movable="true"
                  :resizable="false"
                >
                </DragDropImage>
              </b-col>
            
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group label="Görsel Başlığı (title)" label-for="imageTitle">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Görsel Başlığı (title)"
                  >
                    <b-form-textarea
                      id="imageTitle"
                      v-model="imageTitle"
                      placeholder="Görsel Başlığı (title)"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="imageTitle.length >= chars.imageTitle ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="imageTitle.length >= chars.imageTitle ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ imageTitle.length }}</span>
                      /
                      {{ chars.imageTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label="Görsel Açıklaması (alt text)"
                  label-for="imageAltText"
                >
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Görsel Açıklaması (alt text)"
                  >
                    <b-form-textarea
                      id="imageAltText"
                      v-model="imageAltText"
                      placeholder="Görsel Açıklaması (alt text)"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        imageAltText.length >= chars.imageAltText ? 'text-danger' : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        imageAltText.length >= chars.imageAltText ? 'bg-danger' : ''
                      "
                    >
                      <span class="char-count">{{ imageAltText.length }}</span>
                      /
                      {{ chars.imageAltText }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <DragDropImage
                  ref="refPortraitImage"
                  title="Lider görseli (portrait)"
                  :imageUrl="null"
                  :required="true"
                  :width="400"
                  :height="460"
                  :wheel="false"
                  :movable="true"
                  :resizable="false"
                ></DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Bağlantı Linki" label-for="slug">
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Bağlantı Linki"
                  >
                    <b-form-input
                      id="slug"
                      v-model="slug"
                      placeholder="Bağlantı Linki"
                      :state="errors.length > 0 || availability == false ? false : null"
                      :class="
                        slug.length >= chars.slug || availability == false
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="slug.length >= chars.slug ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ slug.length }}</span>
                      /
                      {{ chars.slug }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <div v-if="availability == false">
                    <p class="text-danger">
                      <small>Lider linki benzersiz olmalıdır.</small>
                    </p>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Meta Açıklaması" label-for="metaTitle">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true, min: 30 }"
                    name="Meta Açıklaması"
                  >
                    <b-form-textarea
                      id="metaTitle"
                      v-model="metaDescription"
                      placeholder="Meta Açıklaması"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        metaDescription.length >= chars.metaDescription
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        metaDescription.length >= chars.metaDescription ? 'bg-danger' : ''
                      "
                    >
                      <span class="char-count">{{ metaDescription.length }}</span>
                      /
                      {{ chars.metaDescription }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <h4 class="mb-2">Alt Metinler</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group label="Gönül İşleri" label-for="subtext1">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: false }"
                    name="Gönül İşleri"
                  >
                    <b-form-textarea
                      id="subtext1"
                      v-model="subTexts[0]"
                      placeholder="Gönül İşleri"
                      rows="5"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        subTexts[0].length >= chars.subTexts[0] ? 'text-danger' : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="subTexts[0].length >= chars.subTexts[0] ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ subTexts[0].length }}</span>
                      /
                      {{ chars.subTexts[0] }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Hayat Gayesi" label-for="subtext1">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: false }"
                    name="Hayat Gayesi"
                  >
                    <b-form-textarea
                      id="subtext1"
                      v-model="subTexts[1]"
                      placeholder="Hayat Gayesi"
                      rows="5"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        subTexts[1].length >= chars.subTexts[1] ? 'text-danger' : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="subTexts[1].length >= chars.subTexts[1] ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ subTexts[1].length }}</span>
                      /
                      {{ chars.subTexts[1] }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Der Ki" label-for="subtext3">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: false }"
                    name="Der Ki"
                  >
                    <b-form-textarea
                      id="subtext3"
                      v-model="subTexts[2]"
                      placeholder="Der Ki"
                      rows="5"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        subTexts[2].length >= chars.subTexts[2] ? 'text-danger' : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="subTexts[2].length >= chars.subTexts[2] ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ subTexts[2].length }}</span>
                      /
                      {{ chars.subTexts[2] }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <h4 class="mb-2">Sosyal Medya Linkleri</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Twitter" label-for="twitter">
                  <b-form-input
                    id="twitter"
                    v-model="social.twitter"
                    placeholder="Twitter"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="LinkedIn" label-for="linkedin">
                  <b-form-input
                    id="linkedin"
                    v-model="social.linkedin"
                    placeholder="LinkedIn"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Facebook" label-for="facebook">
                  <b-form-input
                    id="facebook"
                    v-model="social.facebook"
                    placeholder="Facebook"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Instagram" label-for="instagram">
                  <b-form-input
                    id="instagram"
                    v-model="social.instagram"
                    placeholder="Instagram"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <h4 class="mb-2">Bağlantılar</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Bağlantılar" label-for="text">
                  <div>
                    <b-form
                      ref="form"
                      class="repeater-form mb-5"
                      @submit.prevent="repeateAgain"
                    >
                      <!--  Loop -->
                      <div
                        v-for="(link, index) in links"
                        :id="links[index].id"
                        :key="links[index].id"
                        ref="row"
                      >
                        <b-row>
                          <hr />
                        </b-row>
                        <b-row>
                          <b-col md="12">
                            <b-form-group label="Başlık" label-for="title">
                              <validation-provider
                                #default="{ errors }"
                                :rules="{ required: true }"
                                name="Başlık"
                              >
                                <b-form-input
                                  v-model="links[index].title"
                                  placeholder="Başlık"
                                  :state="errors.length > 0 ? false : null"
                                  :class="
                                    links[index].title.length >= chars.links.title
                                      ? 'text-danger'
                                      : ''
                                  "
                                />
                                <small
                                  class="textarea-counter-value float-right"
                                  :class="
                                    links[index].title.length >= chars.links.title
                                      ? 'bg-danger'
                                      : ''
                                  "
                                >
                                  <span class="char-count">{{
                                    links[index].title.length
                                  }}</span>
                                  /
                                  {{ chars.links.title }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                            <b-form-group label="Bağlantı Linki" label-for="link">
                              <validation-provider
                                #default="{ errors }"
                                :rules="{ required: true }"
                                name="Bağlantı Linki"
                              >
                                <b-form-input
                                  v-model="links[index].link"
                                  placeholder="Bağlantı Linki"
                                  :state="errors.length > 0 ? false : null"
                                  :class="
                                    links[index].link.length >= chars.links.link
                                      ? 'text-danger'
                                      : ''
                                  "
                                />
                                <small
                                  class="textarea-counter-value float-right"
                                  :class="
                                    links[index].link.length >= chars.links.link
                                      ? 'bg-danger'
                                      : ''
                                  "
                                >
                                  <span class="char-count">{{
                                    links[index].link.length
                                  }}</span>
                                  /
                                  {{ chars.links.link }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Remove Button -->
                          <b-col lg="2" md="3" class="mb-50">
                            <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              class="mt-0 mt-md-2"
                              @click="removeItemFaq(index)"
                            >
                              <feather-icon icon="XIcon" class="mr-25" />
                              <span>Sil</span>
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-row>
                          <hr />
                        </b-row>
                      </div>
                    </b-form>
                  </div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="repeateAgain"
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>Ekle</span>
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="mt-5">
                <!-- <b-button
                  class="float-left mt-2"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  @click="postConfirmText(true, true)"
                  >Önizleme
                </b-button> -->
              </b-col>
              <b-col md="6" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false, false)"
                  >
                    <b-spinner v-if="spinner === true && isDraft === false" small />
                    {{
                      spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla"
                    }}
                  </b-button>
                </div>
                <div>
                  <b-button
                    class="float-right mt-2 mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    @click="postConfirmText(true, false)"
                  >
                    <b-spinner v-if="spinner == true && isDraft == true" small />
                    {{
                      spinner == true && isDraft == true
                        ? "Taslağa Kaydediliyor"
                        : "Taslağa Kaydet"
                    }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    Editor,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      slug: "",
      text: "",
      title: "",
      image: null,
      isDraft: false,
      firstName: "",
      lastName: "",
      linkTitle: "",
      imageTitle: "",
      imageAltText: "",
      featuredImage: require("@/assets/images/placeholder/1920x1080.png"),
      metaDescription: "",
      spinner: false,
      availability: true,
      nextTodoId: 2,
      subTexts: ["", "", ""],
      social: {
        twitter: "",
        linkedin: "",
        facebook: "",
        instagram: "",
      },
      links: [
        {
          id: 1,
          title: "",
          link: "",
        },
      ],
      chars: {
        slug: 255,
        title: 255,
        firstName: 255,
        lastName: 255,
        linkTitle: 55,
        imageTitle: 60,
        imageAltText: 140,
        metaDescription: 160,
        subTexts: [255, 255, 255],
        links: {
          link: 255,
          title: 255,
        },
      },
    };
  },
  watch: {
    slug(newSlug, oldSlug) {
      this.slugAvailability(newSlug);
    },
    firstName(newFirstName, oldFirstName) {
      this.slug = this.slugify(`${newFirstName} ${this.lastName} ${this.$i18n.locale}`);
      this.linkTitle = `${newFirstName} ${this.lastName}`;
      this.imageTitle = `${newFirstName} ${this.lastName}`;
      this.imageAltText = `${newFirstName} ${this.lastName}`;
    },
    lastName(newLastName, oldLastName) {
      this.slug = this.slugify(`${this.firstName} ${newLastName} ${this.$i18n.locale}`);
      this.linkTitle = `${this.firstName} ${newLastName}`;
      this.imageTitle = `${this.firstName} ${newLastName}`;
      this.imageAltText = `${this.firstName} ${newLastName}`;
    },
  },
  methods: {
    slugify(text, ampersand = "and") {
      const a = "àáäâèéëêıìíïîòóöôùúüûñçßÿỳýœæŕśşńṕẃǵğǹḿǘẍźḧ";
      const b = "aaaaeeeeiiiiioooouuuuncsyyyoarssnpwggnmuxzh";
      const p = new RegExp(a.split("").join("|"), "g");
      return text
        .toString()
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(p, (c) => b.charAt(a.indexOf(c)))
        .replace(/&/g, `-${ampersand}-`)
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
    slugAvailability(slug) {
      let formData = new FormData();
      formData.append("id", null);
      formData.append("slug", slug);
      endpoints
        .postEducatorsAvailability(formData, this.$i18n.locale, () => {})
        .then((data) => {
          this.availability = data.response.availability;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    repeateAgain() {
      this.links.push({
        id: (this.nextTodoId += this.nextTodoId),
        title: "",
        link: "",
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.links.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    onContext(ctx) {
      this.context = ctx;
    },
    postConfirmText(isDraft, preview) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Yeni eğitmeni kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit(preview);
        }
      });
    },
    postSubmit(preview) {
      if (this.availability) {
        this.$refs.rules.validate().then((success) => {
          if (success) {
            this.spinner = true;

            for (let i = 0; i < this.subTexts.length; i++) {
              if (this.subTexts[i] === "") {
                this.subTexts[i] = null;
              }
            }

            let formData = new FormData();
            formData.append("slug", this.slug);
            formData.append("text", JSON.stringify(this.$refs.refEditor.value));
            formData.append("title", this.title);
            formData.append("firstName", this.firstName);
            formData.append("lastName", this.lastName);
            formData.append("links", JSON.stringify(this.links));
            formData.append("social", JSON.stringify(this.social));
            formData.append("subTexts", JSON.stringify(this.subTexts));
            formData.append("image", this.$refs.refCardImage.image);
            formData.append("portrait", this.$refs.refPortraitImage.image);
            formData.append("isDraft", this.isDraft);
            formData.append("linkTitle", this.linkTitle);
            formData.append("imageTitle", this.imageTitle);
            formData.append("imageAltText", this.imageAltText);
            formData.append("metaDescription", this.metaDescription);
            endpoints
              .postEducators(formData, this.$i18n.locale, () => {})
              .then((data) => {
                this.spinner = false;
                if (data.status) {
                  if (preview == true) {
                    window.open(
                      `${settings.uiBaseUrl}/our-leaders/preview/${this.slug}?hl=${this.$i18n.locale}`,
                      "_blank"
                    );
                  }
                  this.$swal({
                    icon: "success",
                    title: "Kayıt başarılı!",
                    text: "Yeni eğitmen eklendi.",
                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                  }).then((result) => {
                    if (result.value) {
                      this.$router.push({
                        path: `/our-leaders`,
                      });
                    }
                  });
                } else {
                  this.$swal({
                    title: "Hata!",
                    text: "İçerik bağlantı linki benzersiz değil!",
                    icon: "error",
                    confirmButtonText: "Tamam",
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                  }).then((result) => {
                    if (result.value) {
                    }
                  });
                }
              })
              .catch((err) => {
                this.spinner = false;
                console.log(err);
              });
          }
        });
      } else {
        this.$swal({
          title: "Hata!",
          text: "İçerik bağlantı linki benzersiz değil!",
          icon: "error",
          confirmButtonText: "Tamam",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then((result) => {
          if (result.value) {
          }
        });
      }
    },
  },
  created() {},
  destroyed() {},
  mounted() {},
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
